module.exports = __webpack_public_path__ + "img/editor_preview-2.19b006b.webp";